<template>
  <div class="invoice-title">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>发票抬头</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="main">
      <div class="toolbar clearfix">
        <el-input
          v-model="queryName"
          placeholder="按抬头名称查询"
          clearable
          style="width: 220px; margin-right: 8px"
          @keyup.enter.native="queryList"
        />
        <el-button type="primary" size="small" @click="queryList">查询</el-button>
        <el-button type="primary" @click="openAdd">添加发票抬头</el-button>
      </div>

      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="抬头名称" prop="titleName" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.titleName }}</span>
            <el-tag v-if="scope.row.isDefault === '1'" size="mini" type="success" style="margin-left: 6px">默认</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="抬头类型" width="90">
          <template slot-scope="scope">{{ titleTypeText(scope.row.titleType) }}</template>
        </el-table-column>
        <el-table-column label="票种" width="80">
          <template slot-scope="scope">{{ scope.row.invoiceKind === '1' ? '专票' : '普票' }}</template>
        </el-table-column>
        <el-table-column label="税号" prop="dutyParagraph" min-width="160"></el-table-column>
        <el-table-column label="开户银行" prop="bankName" min-width="140"></el-table-column>
        <el-table-column label="银行账号" prop="bankAccount" min-width="140"></el-table-column>
        <el-table-column label="地址电话" prop="addressPhone" min-width="160"></el-table-column>
        <el-table-column label="接收邮箱" prop="email" min-width="150"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" v-if="scope.row.isDefault !== '1'" @click="setDefault(scope.row)">设为默认</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="titleForm.id ? '修改发票抬头' : '添加发票抬头'"
        :visible.sync="dialogVisible"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        width="520px">
        <el-form ref="ruleForm" :model="titleForm" :rules="formRules" label-width="100px">
          <el-form-item label="抬头类型">
            <el-radio-group v-model="titleForm.titleType">
              <el-radio label="1">企业</el-radio>
              <el-radio label="0">个人</el-radio>
              <el-radio label="2">组织</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="票种">
            <el-radio-group v-model="titleForm.invoiceKind">
              <el-radio label="0">普票</el-radio>
              <el-radio label="1">专票</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="抬头名称" prop="titleName">
            <el-input v-model="titleForm.titleName" :placeholder="titleForm.titleType === '0' ? '个人姓名' : '企业/组织全称'"></el-input>
          </el-form-item>
          <el-form-item label="税号" prop="dutyParagraph" v-if="titleForm.titleType !== '0'">
            <el-input v-model="titleForm.dutyParagraph" placeholder="纳税人识别号"></el-input>
          </el-form-item>
          <el-form-item label="开户银行">
            <el-input v-model="titleForm.bankName"></el-input>
          </el-form-item>
          <el-form-item label="银行账号">
            <el-input v-model="titleForm.bankAccount"></el-input>
          </el-form-item>
          <el-form-item label="地址电话">
            <el-input v-model="titleForm.addressPhone" placeholder="注册地址及电话"></el-input>
          </el-form-item>
          <el-form-item label="接收邮箱">
            <el-input v-model="titleForm.email" placeholder="开票后发送至该邮箱"></el-input>
          </el-form-item>
          <el-form-item label="设为默认">
            <el-switch v-model="titleForm.isDefault" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" :loading="submitting" @click="submitForm">保 存</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import api from "@/http/api";

export default {
  name: "InvoiceTitle",
  data() {
    return {
      queryName: "",
      tableData: [],
      dialogVisible: false,
      submitting: false,
      titleForm: this.defaultForm(),
      formRules: {
        titleName: [{ required: true, message: "请输入抬头名称", trigger: "blur" }]
      }
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    defaultForm() {
      return {
        id: null, titleType: "1", invoiceKind: "0", titleName: "",
        dutyParagraph: "", bankName: "", bankAccount: "",
        addressPhone: "", email: "", isDefault: "0"
      };
    },
    titleTypeText(t) {
      return { "0": "个人", "1": "企业", "2": "组织" }[t] || t;
    },
    queryList() {
      api.queryInvoiceTitle({ params: { titleName: this.queryName } }).then(res => {
        if (res.data.code === "ok") {
          this.tableData = res.data.data || [];
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    openAdd() {
      this.titleForm = this.defaultForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },
    handleEdit(row) {
      this.titleForm = Object.assign(this.defaultForm(), row);
      this.dialogVisible = true;
    },
    setDefault(row) {
      const form = Object.assign({}, row, { isDefault: "1" });
      api.updateInvoiceTitle(form).then(res => {
        if (res.data.code === "ok") {
          this.$message.success("已设为默认");
          this.queryList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将删除【" + row.titleName + "】, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.delInvoiceTitle(row.id).then(res => {
          if (res.data.code === "ok") {
            this.$message.success("删除成功");
            this.queryList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {});
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const form = Object.assign({}, this.titleForm);
        if (form.titleType === "0") {
          form.dutyParagraph = "";
        }
        const call = form.id ? api.updateInvoiceTitle(form) : api.addInvoiceTitle(form);
        call.then(res => {
          if (res.data.code === "ok") {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.queryList();
          } else {
            this.$message.error(res.data.message);
          }
        }).finally(() => {
          this.submitting = false;
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.invoice-title {
  padding: 12px;
}
</style>
